export default __webpack_public_path__ + "static/media/circle-exclamation-white.16c34efc.svg";